var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.TmsTable,{attrs:{"data":_setup.data,"selected":_vm.$attrs.selected,"columns":_setup.columns}})
}
var staticRenderFns = []

export { render, staticRenderFns }